import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotadminPermission } from 'data/__generated__';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { CreateTotemClosedDayPopup } from './components/CreateTotemClosedDayPopup';
import { TotemClosedDaysList } from './components/TotemClosedDaysList';

export const TotemClosedDays = () => {
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.totemClosedDays} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreatePopupOpen(true)}
                    requiredPermissions={[TotadminPermission.TotemsManage]}
                >
                    Créer un jour de fermeture pour totem
                </TotemPrimaryButton>
            </Header>
            <Content>
                <ListContainer>
                    <TotemClosedDaysList />
                </ListContainer>
            </Content>
            <CreateTotemClosedDayPopup isOpen={isCreatePopupOpen} setIsOpen={setIsCreatePopupOpen} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
